import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=353434b8&scoped=true&lang=pug&"
import script from "./DashboardChart.vue?vue&type=script&lang=js&"
export * from "./DashboardChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353434b8",
  null
  
)

export default component.exports